export default {
  name: 'UploadPoster',
  
  props: {
    text1: {
      type: String,
      default: '.png'
    },
    text2: {
      type: String,
      default: '.png'
    }
  },

  setup(props){
    return props
  }
}
